var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindowsClosedMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.0048828,16H30.0106201v2h10.9942627c1.6542969,0,3,1.3457031,3,3v14c0,1.6542969-1.3457031,3-3,3H4.6230469 c-0.3408203,0-0.6181641-0.2773438-0.6181641-0.6181641c0-0.0957031,0.0224609-0.1914062,0.0654297-0.2763672l6.8291016-13.6582031 C12.8808594,19.4833984,13.6230469,18,17.0107422,18H24v-2h-6.9892578c-4.6240234,0-5.8574219,2.4667969-7.9003906,6.5527344 L2.28125,36.2109375c-0.1806641,0.3613281-0.2763672,0.7666016-0.2763672,1.1708984 C2.0048828,38.8251953,3.1796875,40,4.6230469,40h36.3818359c2.7568359,0,5-2.2431641,5-5V21 C46.0048828,18.2431641,43.7617188,16,41.0048828,16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0042114,7.4098511l-0.0021973,7.5900879l-0.0011597,4L26,22h2l0.0008545-3.000061l0.0011597-4l0.0021973-7.581665 l3.2887573,3.2887573l1.4140625-1.4140625l-5-5c-0.390625-0.390625-1.0234375-0.390625-1.4140625,0l-5,5l1.4140625,1.4140625 L26.0042114,7.4098511z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsClosedMedium);
export default __webpack_public_path__ + "static/media/windows-closed--medium.3524128481ee074423abd111be3466fb.svg";
export { ForwardRef as ReactComponent };